import { apiClient } from "./apiClient"

/****************************************************************************
 * 
 * Users
 * 
 ***************************************************************************/
export const userApi = {
    fetchUser: async (userId, config, accessToken) => {
        const url = `${config.securityApiUrl}/users/${userId}`
        return await apiClient(
            url,
            accessToken,
            {
                method: 'GET'
            },
            async (response) => {
                return await response.json().then(
                    (result) => {
                        return result.user
                    }
                )
            }
        )
    },
    fetchUserByAccessToken: async (config, accessToken) => {
        const f = "fetchUserByAccessToken"
        let print = false
        const url = `${config.securityApiUrl}/users?accesstoken=${accessToken}`
        return await apiClient(
            url,
            accessToken,
            {
                method: "GET"
            },
            async (response) => {
                return await response.json().then(
                    (c) => {
                        if (!c) {
                            throw new Error("fetching user by access token returned null")
                        }
                        if (print) {
                            console.log(f.concat(": fetched the following users:"))
                            console.log(c)
                        }
                        if (!('user' in c)) {
                            throw new Error(f.concat(": Object parsed from response does not have a user field"))
                        }
                        return c.user[0]
                    }
                )
            }
        )
    },
    fetchUserList: async (businessEntityId, config, accessToken, isSystemUsers = false) => {
        const userType = isSystemUsers ? '&userType=1' : ''
        const url = `${config.securityApiUrl}/businessentities/${businessEntityId}/users?fullDetail=false${userType}`
        return await apiClient(
            url,
            accessToken,
            {
                method: 'GET'
            },
            async (response) => {
                return await response.json().then(
                    (rt) => {
                        return rt.user
                    }
                )
            }
        )
    },
    deactivateUser: async (userId, config, accessToken) => {
        const url = `${config.securityApiUrl}/users/${userId}/deactivate`
        return await apiClient(
            url,
            accessToken,
            {
                method: 'PUT'
            },
            async (response) => {
                return await response.json().then(
                    (deletedUser) => {
                        return deletedUser
                    }
                )
            }
        )
    },
    deleteUser: async (userId, config, accessToken) => {
        const url = `${config.accountServiceBaseUrl}/api/users/${userId}/delete`
        return await apiClient(
            url,
            accessToken,
            {
                method: 'DELETE'
            },
            (response) => {
                return response
            }
        )
    },
    fetchUserPermissionMasks: async (userId, config, accessToken) => {
        const url = `${config.securityApiUrl}/users/${userId}/permissionMasks`
        return await apiClient(
            url,
            accessToken,
            {
                method: "GET"
            },
            async (response) => {
                return await response.json().then(
                    (c) => {
                        if (typeof c != 'object' || !("permissionMask" in c)) {
                            console.error("userApi.fetchPermissionMasks returned an invalid object of type ".concat(typeof c))
                            return null
                        }
                        return c.permissionMask
                    }
                ).catch(
                    (error) => {
                        console.error("Inside userApi.fetchUserPermissionMasks error callback: ".concat(error.toString()))
                        throw error
                    }
                )
            },
            null,
            true,
            false
        )
    },
    fetchUserPermissions: async (userId, config, accessToken) => {
        const url = `${config.accountServiceBaseUrl}/api/users/${userId}/permissions`
        return await apiClient(
            url,
            accessToken,
            {
                method: "GET"
            },
            async (response) => {
                return await response.json().then(
                    (c) => {
                        if (typeof c != 'object' || !("permissions" in c)) {
                            console.error("userApi.fetchUserPermissions returned an invalid object of type ".concat(typeof c))
                            return null
                        }
                        return c.permissions
                    }
                ).catch(
                    (error) => {
                        console.error("Inside userApi.fetchUserPermissions error callback: ".concat(error.toString()))
                        throw error
                    }
                )
            }
        )
    },
    fetchEphemeralUserList: async (businessEntityId, config, accessToken) => {
        const url = `${config.securityApiUrl}/businessentities/${businessEntityId}/ephemeralUsers?fullDetail=false`
        return await apiClient(
            url,
            accessToken,
            {
                method: 'GET'
            },
            async (response) => {
                return await response.json().then(
                    (result) => {
                        return result.ephemeralUser
                    }
                )
            }
        )
    },
    addUser: async (businessEntityId, user, config, accessToken) => {
        const url = `${config.securityApiUrl}/businessentities/${businessEntityId}/users`
        //console.log(user)
        return await apiClient(
            url,
            accessToken,
            {
                method: 'POST',
                body: JSON.stringify(user)
            },
            async (response) => {
                return await response.json().then(
                    (parsed) => {
                        return parsed.user
                    }
                )
            }
        )
    },
    addUserRole: async (businessEntityId, userId, roleId, requestBody, config, accessToken) => {
        const url = `${config.accountApiUrl}/users/${userId}/roles/${roleId}/businessEntities`
        return await apiClient(
            url,
            accessToken,
            {
                method: 'POST',
                body: JSON.stringify(requestBody)
            }
        )
    },
    deleteUserRole: async (userId, roleId, requestBody, config, accessToken) => {
        const url = `${config.accountApiUrl}/users/${userId}/roles/${roleId}`
        return await apiClient(
            url,
            accessToken,
            {
                method: 'POST',
                headers: {
                    'X-HTTP-Method-Override': 'DELETE'
                },
                body: JSON.stringify(requestBody)
            },
            (response) => {
                return response
            }
        )
    },
    createEphemeralUser: async (businessEntityId, config, ephemeralUser, accessToken) => {
        const url = `${config.securityApiUrl}/businessentities/${businessEntityId}/ephemeralUsers`
        return await apiClient(
            url,
            accessToken,
            {
                method: "POST",
                body: JSON.stringify(ephemeralUser)
            }
        )
    },
    updateUser: async (userId, user, config, accessToken) => {
        const url = `${config.securityApiUrl}/users/${userId}`
        return await apiClient(
            url,
            accessToken,
            {
                method: 'PUT',
                body: JSON.stringify(user)
            }
        )
    },
    validateUsername: async (userId, userName, config, accessToken) => {
        userName = encodeURIComponent(userName)
        const url = `${config.accountApiUrl}/validator?username=${userName}&userid=${userId}`
        return await apiClient(
            url,
            accessToken,
            {
                method: 'GET'
            }
        )
    },
    validateEmail: async (userId, email, config, accessToken) => {
        email = encodeURIComponent(email)
        const url = `${config.accountApiUrl}/validator?email=${email}&userid=${userId}`
        return await apiClient(
            url,
            accessToken,
            {
                method: 'GET'
            }
        )
    },
    fetchUserGroups: async (userId, config, accessToken) => {
        const url = `${config.accountApiUrl}/users/${userId}/groups`
        return await apiClient(
            url,
            accessToken,
            {
                method: 'GET'
            },
            async (response) => {
                return await response.json().then(
                    (result) => {
                        return result.groups
                    }
                )
            }
        )
    },
    fetchUserRoles: async (userId, config, accessToken) => {
        const url = `${config.accountApiUrl}/users/${userId}/roleBusinessEntities`
        return await apiClient(
            url,
            accessToken,
            {
                method: 'GET'
            },
            async (response) => {
                return await response.json().then(
                    (result) => {
                        return result.roleBusinessEntities
                    }
                )
            }
        )
    },
    addUserToGroup: async (userId, requestBody, config, accessToken) => {
        const url = `${config.accountApiUrl}/users/${userId}/groups`
        return await apiClient(
            url,
            accessToken,
            {
                method: 'POST',
                body: JSON.stringify(requestBody),
                headers: {
                    'X-HTTP-Method-Override': 'PATCH'
                }
            }
        )
    },
    removeUserFromGroup: async (userId, groupId, config, accessToken) => {
        const url = `${config.accountApiUrl}/users/${userId}/groups/${groupId}`
        return await apiClient(
            url,
            accessToken,
            {
                method: 'POST',
                headers: {
                    "X-HTTP-Method-Override": "DELETE"
                }
            },
            async (response) => {
                return await response
                
            }
        )
    }
}